import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  button: {
    width: "100%",
    background: props =>
      props.disabled
        ? theme.palette.text.disabled
        : props.secondary
        ? theme.palette.jamii.orange
        : theme.palette.jamii.mildBlue,
    borderRadius: theme.spacing(0.5),
    color: props =>
      props.secondary ? theme.palette.jamii.darkAccent : "white",
    fontWeight: props => props.bold && theme.typography.fontWeightBold,
    padding: props =>
      props.small ? theme.spacing(0.5, 1) : theme.spacing(1.5, 4),
    fontSize: props =>
      props.small
        ? theme.typography.caption.fontSize
        : theme.typography.body1.fontSize,
    textTransform: "capitalize",
    "&:hover": { background: theme.palette.primary.main },
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.customShadows(theme.palette.primary.main)
  }
}));
